import React from 'react';

import { Link, Stack } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import { Suppliers } from '@luxuryescapes/contract-svc-bedbank/constants/suppliers';

export default function PreviewCell({ row }: GridRenderCellParams) {
  const lePath = `${window.configs['LUX_CUSTOMER_PORTAL']}/partner/${row.slug}/${row.id}?preview=true&previewHash=${row.previewHash}`;
  let externalPath = null;
  if (row.masterSupplier === Suppliers.expedia) {
    externalPath = `${window.configs['EXPEDIA_PORTAL']}/${row.externalSlug}`;
  }
  if (row.masterSupplier === Suppliers.agoda) {
    externalPath = `${window.configs['AGODA_PORTAL']}/${row.externalSlug}`;
  }

  return (
    <Stack direction="row" spacing={1}>
      <Link href={lePath}>LE</Link>
      {externalPath ? <Link href={externalPath}>{row.masterSupplier}</Link> : ''}
    </Stack>
  );
}
